(ns frontend.ui.component.lp-portal.report.component.overview-figures.pdf-view
  (:require
   [clojure.string :as s]
   [common.util :as cu]
   [frontend.ui.style.theme.core :as theme]))

(defn- big-figure
  "Table row of a figure on top of its label. Watch-out: this only works inside a `:table` (because
  we use `:border` and `:borderColor`). See `big-figure-row` for simpler usage."
  [label value comment {:keys [separator? margin-bottom] :or {separator? true}}]
  (let [border-color (theme/color [:pdf :border])]
    {:border      (if (= (theme/get-theme) :theme.lp-portal/lifeline)
                    [false false false false]
                    [true true true true])
     :borderColor [border-color border-color border-color border-color]
     :fillColor   (theme/color [:lp-report :big-figures :bg])
     :margin      [0 0 0 margin-bottom]
     :stack       [(merge {:text      value
                           :bold      true
                           :fontSize  20
                           :alignment :center
                           :margin    [0 8 0 -10]
                           :color     (theme/color [:lp-report :big-figures :pdf :value])}
                          (when (= (theme/get-theme) :theme.lp-portal/lifeline)
                            {:font "SuperiorTitleBlack"}))
                   {:text      label
                    :bold      true
                    :color     (theme/color [:lp-report :big-figures :pdf :label])
                    :alignment :center
                    :margin    [0 0 0 0]}
                   {:text      (when-not (= "-" comment) comment)
                    :bold      true
                    :color     (theme/color [:lp-report :big-figures :pdf :comment])
                    :alignment :center
                    :fontSize  7
                    :margin    [0 0 0 0]}]}))

(defn table
  ([figures figures-per-row]
   (table figures figures-per-row {:row-gap 0}))
  ([figures figures-per-row {:keys [row-gap]}]
   (let [filtered-figures (->> figures
                               (filterv (fn [[label value comment]]
                                          (not (cu/blank-value? value)))))
         rows (->> filtered-figures
                   (partition figures-per-row figures-per-row (repeat nil)))
         table
         {:margin (if (= (theme/get-theme) :theme.lp-portal/lifeline)
                    [0 0 0 0]
                    [0 0 20 10])
          :layout {:hLineWidth (fn [i] 0.5)
                   :vLineWidth (fn [i] 0.5)}
          :table  {:widths "*"
                   :body
                   (->>
                    rows
                    (map-indexed
                     (fn [row-index figures-row]
                       (->> figures-row
                            (map (fn [bf]
                                   (if (nil? bf)
                                     {:border [false false false false]
                                      :text   ""}
                                     (big-figure (first bf)
                                                 (second bf)
                                                 (last bf)
                                                 {:separator?    true
                                                  :margin-bottom (when-not (= (inc row-index)
                                                                              (count rows))
                                                                   row-gap)})))))))
                    (vec))}}]
     (when-not (empty? rows) table))))
